module.exports = __webpack_public_path__ + "img/zx_cup2.ec9dd45c.png";